import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { ObjectTargetsTranslator } from "./ObjectTargetsTranslator";
import { LinkedPageObjectTranslator } from "./LinkedPageObjectTranslator";

export class ScriptExecuteTriggerBehaviorTranslator extends ObjectTargetsTranslator<ILinkedPageObjectSpecifiable> {
  constructor() {
    super("script-link-output", new LinkedPageObjectTranslator());
  }
}
